<template>
  <BasicModal
    :title="'タスク削除'"
    :isShowModal="isShowModal"
    :canCancel="true"
    @cancel="cancel">
    <div class="-container">
      <h2 class="msg-title">
        {{ deleteTask.title }}を削除してもよろしいでしょうか？
      </h2>
    </div>
    <!-- フッターアクション -->
    <div class="footer-box">
      <button class="button" @click="cancel">キャンセル</button>
      <button class="button is-primary" @click="deleteUserTask(deleteTask.pk)">削除する</button>
    </div>
  </BasicModal>
</template>

<script>
import BasicModal from '@/components/Modals/BasicModal'
export default {
  components: {
    BasicModal
  },
  props: {
    isShowModal: {
      type: Boolean,
      required: true
    },
    deleteTask: {
      type: Object,
      required: true
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel', {
        flg: false,
        task: null
      })
    },
    deleteUserTask (pk) {
      this.$emit('deleteUserTask', pk)
      this.cancel()
    },
  }
}
</script>

<style lang="scss" scoped>
.-container {
  padding: 32px;
  h2 {
    font-weight: 600;
    font-size: 18px;
    margin-bottom: 16px;
  }
}
.input-field {
  padding: 8px;
}
.footer-box {
  width: 100%;
  height: 64px;
  border-top: solid thin #ccc;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
  button {
    width: 47%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Calendar/organisms/ModalDeleteTask.vue